import { gql } from "@apollo/client";

export const deleteProductsFromGroup = gql`
  mutation DeleteProductsFromGroup($groupId: uuid!, $productIds: [uuid!]!) {
    deleteProductGroupProduct(
      where: { productGroupId: { _eq: $groupId }, productId: { _in: $productIds } }
    ) {
      affected_rows
    }
  }
`;

export type DeleteProductsFromGroupVariables = {
  groupId: string;
  productIds: string[];
};
